<ng-select [items]="currencyPairs"
           (ngModelChange)="propagateChange($event)"
           [ngModelOptions]="{standalone: true}"
           [(ngModel)]="sixLetterCode"
           [inputAttrs]="{'data-lpignore': 'true'}"
           placeholder="{{sixLetterCode}}"
           [clearable]="false"
           #cpSelect
           bindLabel="sixLetterCode"
           bindValue="sixLetterCode"
           [hideSelected]="true"
           class="sixletter-dropdown">
  <ng-template ng-option-tmp let-item="item">
    <label class="mb-0" id="{{item.sixLetterCode}}">{{item.sixLetterCode | formatSixLetter}}</label>
  </ng-template>
</ng-select>
